// noinspection JSUnusedGlobalSymbols

import { ComboBoxOption, DropdownOption, DropdownProps } from '../components/Dropdown/BaseDropdown'

export function onMultiSelectDropdownChange(
    option?: DropdownOption | ComboBoxOption,
    selectedKeys?: (string | number)[],
    forceSelect?: boolean,
): (string | number)[] {
    if (option) {
        const keys = [...(selectedKeys || [])]
        // We can force select an option, because it will only carry the selected property when the selection is
        // propagated by the ComboBox itself, but not when we manually trigger it.
        if (option.selected || forceSelect) {
            // Add the option if it's checked.
            if (keys.indexOf(option.key) === -1) {
                keys.push(option.key)
            }
        } else {
            // Remove the option if it's unchecked.
            let i: number
            while ((i = keys.indexOf(option.key)) > -1) {
                keys.splice(i, 1)
            }
        }
        return keys
    }

    return []
}

export function getDropdownProps<D>(
    value: string | number | (string | number)[],
    error: string | string[],
    setFieldValue: (value: string | number | (string | number)[], data?: D) => void,
    multiSelect: boolean = false,
): Pick<DropdownProps<D>, 'setSelectedKey' & 'multiselect' & 'selectedKey' & 'errorMessage'> {
    return {
        setSelectedKey: (option?: ComboBoxOption<D>, force?: boolean) => {
            setFieldValue(multiSelect ? onMultiSelectDropdownChange(option, value as (string | number)[], force) : option?.key, option?.data)
        },
        multiSelect,
        // Fluent UI will default to an uncontrolled component when the value is undefined.
        selectedKey: value ?? null,
        errorMessage: error,
    }
}

export const getFieldNameValue = (values, fieldValue: string) => {
    const splitName = fieldValue.split('.')
    if (splitName.length === 1) {
        return values[splitName[0]]
    }

    const arrayIndex = splitName[0].match(/\[(\d+)]/)
    if (arrayIndex) {
        const arrayName = splitName[0].split('[')[0]
        return getFieldNameValue(values[arrayName][arrayIndex[1]], fieldValue.substring(fieldValue.indexOf('.') + 1))
    }

    return getFieldNameValue(values[splitName[0]], fieldValue.substring(fieldValue.indexOf('.') + 1))
}
